<template>
  <span class="field">
    <input
      v-if="!maskEnabled"
      class="field__input"
      :type="type"
      :name="name"
      :id="name"
      v-bind="$attrs"
      autocomplete="off"
      @input="$emit('input', $event.target.value)"
      :value="value"
    />
    <the-mask
      class="field__input"
      v-if="maskEnabled"
      :mask="['+38(0##)###-##-##']"
      :masked="false"
      @input="value => $emit('input', '+380' + value)"
      :value="value"
    />
  </span>
</template>

<script>
export default {
  props: {
    name: {
      required: true,
      type: String
    },
    type: {
      required: false,
      type: String,
      default: 'text'
    },
    value: {
      required: false,
      type: String,
      default: ''
    },
    maskEnabled: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.field {
  display: block;

  &__input {
    width: 100%;
    height: 100%;
    min-height: 36px;
    padding: 0 20px;
    color: #282830;
    font-family: $ToyotaBook;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    border: none;
    border-radius: 4px;
    background-color: #f0f0f0;
    box-sizing: border-box; 
    outline:none;
    &:focus {
      background-color: #fff;
      box-shadow: 0 2px 10px 0 rgba(0,0,0,0.15);
    }

    &::placeholder {
      color:  #6a6b70;
      font-family: inherit;
      font-size: inherit;
      font-weight: inherit;
      line-height: inherit;
    }
  }
}

@include media-min($desktop-width) {
  .field {
    &__input {
      min-height: 48px;
      font-size: 16px;
      font-weight: 400;
      line-height: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/_UI/BaseField.vue